import { Spinner } from '@sunucupark/ui';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import type { ComposeScreenProps } from './ComposeScreen';

/** Props of {@link ComposePage}. */
export type ComposePageProps = ComposeScreenProps;

/**
 * The composer as its own page, behind a dynamic import of its own — so the
 * shell can name the route component in its route table without the whole
 * composer joining the first download (ADR 0006, bundle budget).
 */
const ComposeScreen = lazy(() =>
  import('./ComposeScreen').then((module) => ({ default: module.ComposeScreen })),
);

/**
 * A draft that has been popped out of the docked stack and now owns the whole
 * page (`/compose/$draftId`).
 *
 * @example
 * component: lazyRouteComponent(() => import('@/features/compose'), 'ComposePage')
 */
export function ComposePage(props: ComposePageProps) {
  const { t } = useTranslation();
  return (
    <Suspense
      fallback={
        <p role="status" className="flex h-dvh items-center justify-center gap-2 text-text-secondary">
          <Spinner size="sm" />
          {t('compose.loading')}
        </p>
      }
    >
      <ComposeScreen {...props} />
    </Suspense>
  );
}
